import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

export interface SignatureInfo {
  signatureDate: string;
  businessName: string;
  document: string;
}

export const addSignatureInfoToPdf = async (
  base64Content: string,
  signatureInfo: SignatureInfo
): Promise<Blob> => {
  try {
    // Limpa o base64 (remove prefixo se existir)
    const cleanBase64 = base64Content.replace(/^data:application\/pdf;base64,/, '');

    // Converte base64 para Uint8Array
    const pdfBytes = Uint8Array.from(
      atob(cleanBase64),
      c => c.charCodeAt(0)
    );

    // Carrega o PDF
    const pdfDoc = await PDFDocument.load(pdfBytes);

    // Pega a última página
    const pages = pdfDoc.getPages();
    const lastPage = pages[pages.length - 1];
    const { width, height } = lastPage.getSize();

    // Embute fonte
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const fontSize = 10;
    const margin = 50;

    // Posição inicial (parte inferior da página)
    let yPosition = margin + 60;

    // Adiciona box de fundo
    lastPage.drawRectangle({
      x: margin - 10,
      y: yPosition - 10,
      width: width - (margin * 2) + 20,
      height: 70,
      borderColor: rgb(0.059, 0.173, 0.157), // rgb(15, 44, 40) normalizado
      borderWidth: 1,
      color: rgb(0.95, 0.98, 0.97), // fundo levemente esverdeado
    });

// Adiciona título
    lastPage.drawText('ASSINADO DIGITALMENTE', {
      x: margin,
      y: yPosition + 45,
      size: fontSize + 2,
      font: font,
      color: rgb(0.059, 0.173, 0.157), // rgb(15, 44, 40) normalizado
    });

// Adiciona linha separadora
    lastPage.drawLine({
      start: { x: margin, y: yPosition + 40 },
      end: { x: width - margin, y: yPosition + 40 },
      thickness: 1,
      color: rgb(0.5, 0.6, 0.55), // cinza esverdeado
    });

    // Adiciona informações
    lastPage.drawText(`Data de Assinatura: ${signatureInfo.signatureDate}`, {
      x: margin,
      y: yPosition + 25,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    lastPage.drawText(`${signatureInfo.document.length === 18 ? 'Razão Social' : 'Nome'} : ${signatureInfo.businessName}`, {
      x: margin,
      y: yPosition + 10,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    lastPage.drawText(`Documento: ${signatureInfo.document}`, {
      x: margin,
      y: yPosition - 5,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    // Salva o PDF modificado
    const modifiedPdfBytes = await pdfDoc.save();

    // Retorna como Blob
    return new Blob([modifiedPdfBytes], { type: 'application/pdf' });
  } catch (error) {
    console.error('Erro ao adicionar informações ao PDF:', error);
    throw new Error('Erro ao processar PDF');
  }
};
